/* unplugin-vue-components disabled */import { render } from "./company-type.vue?vue&type=template&id=37014278&scoped=true"
import script from "./company-type.vue?vue&type=script&lang=js"
export * from "./company-type.vue?vue&type=script&lang=js"

import "./company-type.vue?vue&type=style&index=0&id=37014278&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37014278"],['__file',"src/pages/pulse/company-type.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37014278"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37014278', __exports__)) {
    api.reload('37014278', __exports__)
  }
  
  module.hot.accept("./company-type.vue?vue&type=template&id=37014278&scoped=true", () => {
    api.rerender('37014278', render)
  })

}


export default __exports__